<template>
  <vue-modal id="payNegativeBalanceModal"
             classes="vue-modal-container"
             height="auto"
             name="pay-negative-balance-modal"
             width="300px">
    <div class="header">
      <h3>{{ trans.header }}</h3>
      <button class="close-modal"
              @click="$modal.hide('pay-negative-balance-modal')">
        <i class="close icon"/>
      </button>
    </div>
    <div class="content">
      <p>
        <strong>{{ trans.paymentAmount }}: {{ balanceInCurrentClient }} Ft</strong>
      </p>
    </div>

    <div class="actions">
      <div class="ui positive approve button small-action-btn"
           @click="pay">{{ trans.payBtnText }}
      </div>
      <div class="ui cancel button small-action-btn"
           @click="$modal.hide('pay-negative-balance-modal')">{{ trans.cancelModal }}
      </div>
    </div>
  </vue-modal>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

export default {
  data () {
    return {}
  },
  methods: {
    reserve (wantToPay = false) {
      let reservationData = {
        subjectID: this.subjectId,
        start: this.startTime,
        wantToPay: wantToPay,
      }
      if (this.paymentConfig && !this.paymentConfig?.isRequiredToPayTheNegativeBalance) {
        reservationData.wantToPayNegativeBalance = this.wantToPayNegativeBalance
      }
      this.$parent.$emit('create-new-reservation', reservationData)
      this.$modal.hide('pay-negative-balance-modal')
    },
    pay () {
      console.log('pay.........')
      this.$emit('pay', this.getCurrentClientBalance)
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.payNegativeBalanceModal,
    }),
    ...mapGetters(['getCurrentClientBalance', 'getCurrentUserPaymentConfig']),
    paymentConfig () {
      const clients = this.$store.state.clients
      const currentClientDomain = this.$store.state.currentClientDomain
      for (let client of clients) {
        if (client?.domain === currentClientDomain) {
          return client.config?.payment
        }
      }
      return false
    },
    balanceInCurrentClient () {
      const currentClientDomain = this.$store.state.currentClientDomain
      const balances = this.$store.state.balances
      for (let balance of balances) {
        if (balance.client === currentClientDomain) {
          return balance?.amount
        }
      }
      return false
    },
  },
}
</script>

<style scoped>
.small-action-btn {
  width: 48%;
}
</style>
